<script setup lang="ts">
/**
 * Photo ou capture mise en valeur des pages charte « apple » (Karim
 * 2026-10-18) : coins très arrondis, ombre douce, pastille facultative en
 * verre dépoli posée en bas à gauche. `prioritaire` pour le haut de page.
 */
const props = withDefaults(
  defineProps<{
    image: string;
    largeur: number;
    hauteur: number;
    alt: string;
    pastille?: string;
    pastilleIcone?: string;
    prioritaire?: boolean;
    sizes?: string;
    /** Largeur maximale du cadre (classe Tailwind). */
    max?: string;
  }>(),
  {
    pastille: undefined,
    pastilleIcone: "i-lucide-sparkles",
    prioritaire: false,
    sizes: "xs:92vw sm:92vw md:600px lg:640px",
    max: "max-w-[640px]",
  },
);
</script>

<template>
  <div class="relative mx-auto w-full" :class="props.max">
    <div class="overflow-hidden rounded-[28px] bg-[#f5f5f7] shadow-[0_0_0_1px_rgba(0,0,0,0.04),0_40px_80px_-40px_rgba(0,0,0,0.35)]">
      <NuxtImg
        :src="props.image"
        :alt="props.alt"
        :width="props.largeur"
        :height="props.hauteur"
        :sizes="props.sizes"
        :loading="props.prioritaire ? 'eager' : 'lazy'"
        :fetchpriority="props.prioritaire ? 'high' : undefined"
        :preload="props.prioritaire || undefined"
        class="block h-auto w-full"
      />
    </div>
    <span
      v-if="props.pastille"
      class="absolute -bottom-4 left-5 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-4 py-2 text-[13px] font-semibold text-[#1d1d1f] shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_12px_28px_-12px_rgba(0,0,0,0.3)] backdrop-blur"
    >
      <UIcon :name="props.pastilleIcone" class="size-4 text-(--color-main)" />
      {{ props.pastille }}
    </span>
  </div>
</template>
